var jingdian = [
    // —————— 市南区（核心城区） ——————
    [120.319365, 36.061686, '栈桥'],
    [120.350903, 36.053625, '八大关风景区'],
    [120.352169, 36.050649, '第二海水浴场'],
    [120.384576, 36.062740, '五四广场'],
    [120.398984, 36.057400, '奥帆中心'],
    [120.336020, 36.057077, '青岛海底世界'],
    [120.327714, 36.054786, '中国海军博物馆'],
    [120.333117, 36.055007, '鲁迅公园'],
    [120.323783, 36.053098, '小青岛公园'],
    [120.331561, 36.066446, '信号山公园'],
    [120.332953, 36.064939, '迎宾馆（德国总督楼旧址）'],
    [120.345974, 36.078675, '青岛啤酒博物馆'],
    [120.320588, 36.068143, '天主教堂（圣弥厄尔大教堂）'],
    [120.328151, 36.066718, '江苏路基督教堂'],
    [120.331652, 36.059756, '大学路网红墙'],

    // —————— 崂山区 ——————
    [120.561993, 36.141207, '崂山风景区（巨峰/太清/北九水）'],
    [120.507487, 36.098387, '石老人观光园'],
    [120.441559, 36.070541, '青岛极地海洋世界'],
    [120.521213, 36.402937, '雕塑园'],
    [120.468010, 36.091680, '石老人海水浴场'],
    [120.646526, 36.248523, '二龙山生态旅游区'],
    [120.542081, 36.251370, '北涧天一顺生态园'],
    [120.559287, 36.244128, '大崂樱桃谷'],

    // —————— 西海岸新区（黄岛） ——————
    [120.245130, 35.957210, '金沙滩景区'],
    [120.208900, 35.924971, '银沙滩'],
    [120.203926, 35.931896, '唐岛湾公园'],
    [120.058125, 35.981680, '青岛森林野生动物世界'],
    [120.064213, 35.987563, '珠山国家森林公园'],
    [120.110849, 35.911238, '青岛东方影都'],
    [120.059932, 35.881480, '红树林度假世界'],
    [119.909864, 35.648581, '琅琊台风景区'],
    [119.979236, 35.778825, '大珠山风景名胜区'],
    [119.795571, 35.797989, '藏马山旅游度假区'],
    [120.095287, 35.905940, '青岛电影博物馆'],

    // —————— 城阳区 ——————
    [120.284091, 36.209227, '青岛方特梦幻王国'],
    [120.416902, 36.147704, '宝龙乐园'],
    [120.395192, 36.285939, '青岛奥林匹克雕塑文化园'],
    [120.396128, 36.301180, '青岛新天地'],
    [120.271198, 36.314397, '羊毛沟花海湿地'],

    // —————— 即墨区 ——————
    [120.186576, 36.427245, '即墨古城'],
    [120.646311, 36.332153, '即墨鹤山风景区'],
    [120.931639, 36.496948, '宝湖奔马园'],
    [120.530208, 36.363108, '即墨老酒博物馆'],
    [120.382665, 36.066938, '青岛非物质文化遗产博览园'],
    [120.200337, 35.917828, '田横岛旅游度假区'],

    // —————— 胶州市 ——————
    [120.079651, 36.271078, '胶州少海风景区'],
    [120.034910, 36.260350, '胶州三里河公园'],
    [120.012006, 36.255122, '高凤翰纪念馆'],
    [119.961747, 36.114979, '胶州艾山风景区'],

    // —————— 平度市 ——————
    [120.002875, 36.882294, '大泽山风景区'],
    [119.986400, 36.928766, '茶山风景区'],
    [119.888561, 36.795739, '平度文王山'],

    // —————— 莱西市 ——————
    [120.453197, 36.931051, '莱西湖生态休闲区'],
    [120.528445, 36.859074, '莱西月湖公园'],
    [120.435005, 36.894780, '莱西仙足山风景区'],
    [120.533331, 36.857010, '崔子范美术馆'],

    // —————— 亲子乐园 & 儿童友好型重点景区 ——————
    [120.284091, 36.209227, '青岛方特梦幻王国'],
    [120.441559, 36.070541, '青岛极地海洋世界'],
    [120.336020, 36.057077, '青岛海底世界'],
    [120.058125, 35.981680, '青岛森林野生动物世界'],
    [120.931639, 36.496948, '宝湖奔马园'],
    [120.395192, 36.285939, '青岛奥林匹克雕塑文化园（儿童乐园）'],
    [120.271198, 36.314397, '羊毛沟花海湿地（萌宠+无动力乐园）'],
    [120.063632, 35.882682, '红树林童梦天地'],
    [120.345974, 36.078675, '青岛啤酒博物馆（亲子互动体验）'],
    [120.079651, 36.271078, '胶州少海风景区（儿童游乐区）']
];

var qingdao = [
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    }
]


export default qingdao